import { axiosInstance } from "../core/http";

export const activityApi = {
  getPlayersPerTeam: (activityId) =>
    axiosInstance.get(`/api/activities/${activityId}/players-per-team/`),

  updatePlayersPerTeam: (activityId, playersPerTeam) =>
    axiosInstance.patch(`/api/activities/${activityId}/players-per-team/`, {
      players_per_team: playersPerTeam,
    }),
};

